// `window` is provided by ESLint's globals.browser preset (eslint.config.js).
/*
 * src/data/heroMetrics.js — single source of truth for the three Hero metric tiles.
 *
 * DO NOT inline numbers anywhere else. Hero.jsx and Case.jsx read from
 * window.HEALBOT_HERO_METRICS; the placeholder regression test
 * (`tests/check-placeholders.mjs`) fails the build if a literal `X%` /
 * `X хв` / `X min` / `X hrs/week` slips into a rendered snapshot.
 *
 * Each metric:
 *   { value, unit, source, window, attribution, measuredAt }
 *
 * - `value` is `null` until PR-DEP-2 (source-of-truth metrics document) lands;
 *   while `null`, Hero.jsx renders the literal "X" (preserved as a safety
 *   fallback so the page never goes blank if the data file fails to load).
 * - `unit` is the locale-agnostic suffix; locale-specific suffix text comes
 *   from `hero.metric.N.unit` i18n keys.
 * - `source` is a free-form attribution string referencing the ticket /
 *   document. Never put raw spreadsheets here.
 * - `window` is an ISO date range (`"YYYY-MM-DD/YYYY-MM-DD"`) describing the
 *   measurement period. The case-study page surfaces it as a footnote.
 * - `attribution` is `"aggregate"` (anonymous-aggregate, default) or
 *   `"attributable"` (clinic-named, requires PR-DEP-1 sign-off).
 * - `measuredAt` is the ISO date when the snapshot was captured (used to
 *   compute "data is N months old" warnings — risk R2 in the plan).
 *
 * Wiring: this script MUST load BEFORE src/Hero.jsx and src/Case.jsx in
 * index.html and in every per-locale snapshot produced by
 * `scripts/build-locale-html.js`. The build script injects it for both the
 * root `/index.html` family and the new `/case/{slug}/index.html` family.
 *
 * After PR-DEP-2 sign-off, fill the three `value` fields with the approved
 * numbers and run `node tests/check-placeholders.mjs` — it must EXIT 0
 * before the rollout commit (Phase H.2 in the plan).
 */
window.HEALBOT_HERO_METRICS = {
  bookingsUplift: {
    value: null,
    unit: "%",
    source: "TBD-PR-DEP-2",
    window: "TBD",
    attribution: "aggregate",
    measuredAt: null,
  },
  avgReplyTime: {
    value: null,
    unit: "min",
    source: "TBD-PR-DEP-2",
    window: "TBD",
    attribution: "aggregate",
    measuredAt: null,
  },
  frontDeskHours: {
    value: null,
    unit: "hrs/week",
    source: "TBD-PR-DEP-2",
    window: "TBD",
    attribution: "aggregate",
    measuredAt: null,
  },
};
